import "@Styles/Shared/MyAccount/Templates/StandardAnonymousCta/standardAnonymousCta_sm.less";
import "@Styles/Shared/MyAccount/BC/standardAnonymousCta_sm.less";
import "@Styles/Shared/MyAccount/Templates/StandardAnonymousCta/standardAnonymousCta_md.less";
import "@Styles/Shared/MyAccount/BC/standardAnonymousCta_md.less";
import "@Styles/Shared/MyAccount/Templates/StandardAnonymousCta/standardAnonymousCta_lg.less";
import "@Styles/Shared/MyAccount/BC/standardAnonymousCta_lg.less";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import signup from '../NewsletterSignup/anonymousNewsletterSignup';
import { getRegUrlWithEmailParam } from '../_util';
export default {
  props: {
    config: {
      type: Object
    }
  },
  data: function data() {
    return {
      settings: this.config ? this.config.settings : {},
      newsletters: this.config ? this.config.unsubscribedNewsletters : [],
      isSubscribed: false,
      regUrl: '',
      nctaContentContainerBackground: ''
    };
  },
  components: {
    'signup': signup
  },
  created: function created() {
    this.$_setStyleOverrides();

    if (this.settings && this.settings.patternImageUrl && this.settings.location == 'Footer') {
      this.nctaContentContainerBackground = 'background-image: url("' + this.settings.patternImageUrl + '")';
    }
  },
  methods: {
    showThankYou: function showThankYou(data) {
      this.isSubscribed = true;
      this.regUrl = getRegUrlWithEmailParam(this.settings.registrationUrl, data.email);
    },
    $_setStyleOverrides: function $_setStyleOverrides() {
      var styles = {
        backgroundColor: this.settings.backgroundColor,
        patternImageUrl: this.settings.patternImageUrl,
        largeBackgroundImageUrl: this.settings.standardLargeImageUrl,
        smallBackgroundImageUrl: this.settings.standardSmallImageUrl
      };
      this.$emit('set-style-overrides', styles);
    }
  }
};